import { notification } from "antd";

import history from "../../routes/history";
import api from "../api";
import ApiException from "../exception/ApiException";


const registerMotorista = async (values) => {
  try {
    await api.post("motoristas", values);
    history.push("/motoristas");
    notification.open({
      message: "Motorista adicionado com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

const getMotorista = async (id) => {
  try {
    const { data } = await api.get(`motoristas/${id}`);
    return data;
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

const deleteMotorista = async (id) => {
  try {
    await api.delete(`motoristas/${id}`);
    notification.open({
      message: "Motorista deletado com sucesso",
    });
  } catch (error) {
    notification.open({
      message: error.response.data.error,
    });
  }
};

const getMotoristas = async (page, filter = "", paginated = "") => {
  const { data: motoristas } = await api.get(
    `motoristas?page=${page}&filter=${filter}&paginated=${paginated}`
  );
  return motoristas;
};

const updateMotorista = async (gestante, values) => {
  try {
    values.id = gestante.id;
    await api.put("motoristas", values);
    history.push("/motoristas");
    notification.open({
      message: "Motorista atualizado com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

export {
  registerMotorista,
  deleteMotorista,
  getMotorista,
  getMotoristas,
  updateMotorista,
};
